// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__Xmb0N","transparent":"Button_transparent__RDP6P","blue":"Button_blue__0r3Dp","white":"Button_white__ZJE4q","red":"Button_red__L7+HW"};